export default __webpack_public_path__ + "static/media/Flag_of_Bahrain.e48a5d3e.svg";